export enum ConnectionPermissions {
  Connection = 'connection',
}
